// tbl_student_ans_attempts.student_answer holds a PDF url for a legacy worksheet
// and a marking result for an interactive one. Anything rendering it has to tell
// them apart, or a JSON blob ends up being handed to the PDF viewer.
export const INTERACTIVE_RESULT_TYPE = "interactive"

export const parseInteractiveResult = value => {
  if (!value || typeof value !== "string") return null
  const trimmed = value.trim()
  if (trimmed.charAt(0) !== "{") return null
  try {
    const parsed = JSON.parse(trimmed)
    return parsed && parsed.type === INTERACTIVE_RESULT_TYPE ? parsed : null
  } catch (e) {
    return null
  }
}

// The tutor's own marked copy if there is one, otherwise what the student filled in.
export const interactivePdfUrl = result =>
  (result && (result.markedPdfUrl || result.filledPdfUrl)) || ""
